import { render, staticRenderFns } from "./facilitySpectaculars.vue?vue&type=template&id=47a5fffa&scoped=true"
import script from "./facilitySpectaculars.vue?vue&type=script&lang=js"
export * from "./facilitySpectaculars.vue?vue&type=script&lang=js"
import style0 from "./facilitySpectaculars.vue?vue&type=style&index=0&id=47a5fffa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47a5fffa",
  null
  
)

export default component.exports